module.exports = {
    WALLET_SUPPORT:"The current wallet is not supported",
    CHAIN_SUPPORT:"The current primary chain is not supported",
    INIT_FAIL:"Init fail",
    REJECT_CONNECT:"Connection denied"
}